import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import AudiobooksHero from './components/AudiobooksHero';
import AudiobooksList from './components/AudiobooksList';

const AudiobooksPage = () => {
  return (
    <div className="min-h-screen bg-[#FDFBF7]">
      <Navbar />
      <AudiobooksHero />
      <AudiobooksList />
      <Footer />
    </div>
  );
};

export default AudiobooksPage;
